import { FirebaseMessaging } from "@capacitor-firebase/messaging"
import posthog from "posthog-js"
import { z } from "zod"
import { detectPlatform } from "@/shared/lib/platform"
import { notificationTaps } from "../model/queue"

const pushDataSchema = z.object({ notification_id: z.coerce.number() })

/**
 * Attached in `prepare()`, before the first render and independently of
 * `initPushNotifications()` — that one waits for authentication, this one
 * needs no permission. Capacitor retains the tap until the first listener, so
 * a cold start receives it too.
 */
export function listenPushTaps(): void {
	const platform = detectPlatform()
	if (platform !== "android" && platform !== "ios") return

	void FirebaseMessaging.addListener("notificationActionPerformed", (event) => {
		const notificationId = pushDataSchema.safeParse(event.notification.data)
			.data?.notification_id

		notificationTaps.add({
			notificationId: notificationId ?? null,
			source: "push",
		})
	}).catch((error) => {
		posthog.captureException(error, { scope: "push.listener" })
	})
}
